<template>
  <div>
    <div class="message">
      <div v-for="item in formList" :key="item.field">
        <div class="label">{{item.label}}</div>
        <div class="info">
          <input
            v-if="item.field === 'expenseType'"
            @click="showPicker = true"
            :value="getExpenseTypeName" :placeholder="item.placeholder" @input="handleCallBack" :readonly="item.readonly" @focus="onFocus(item)"
          />
          <input
            v-else
            v-model="form[item.field]" :placeholder="item.placeholder" @input="handleCallBack" :readonly="item.readonly" @focus="onFocus(item)"
          />
          <van-popup v-model="showPicker" position="bottom" round>
            <div class="popup-content">
              <header>
                <span @click="showPicker = false">取消</span>
                <span @click="onConfirm">确认</span>
              </header>
              <div class="columns">
                <van-checkbox-group v-model="expenseTypes">
                  <van-cell-group>
                    <van-cell
                      v-for="(item) in getExpenseTypeMap"
                      clickable
                      :key="item.value"
                      :title="`${item.label}`"
                      @click="toggle(item)"
                    >
                      <template #right-icon>
                        <van-checkbox icon-size="18" :name="item" />
                      </template>
                    </van-cell>
                  </van-cell-group>
                </van-checkbox-group>
              </div>
            </div>
          </van-popup>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Popup, picker, Checkbox, CheckboxGroup, CellGroup, Cell } from 'vant'
import { ExpenseTypeMap } from '@assets/config'
export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Popup.name]: Popup,
    [picker.name]: picker
  },
  props: {
    formList: {
      type: Array,
      default: () => []
    },
    formData: {
      type: Object,
      default: () => {}
    },
    defaultIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      form: {},
      showPicker: false,
      expenseTypes: [],
      checkIndexs: []
    }
  },
  watch: {
    formData: {
      handler (v) {
        console.log(v, '修改了')
        this.form = { ...this.formData }
        if (this.form.expenseType) {
          this.setExpenseTypes(this.form.expenseType)
        }
      },
      deep: true
    }
  },
  computed: {
    isCheck () {
      return (v) => {
        console.log((this.form.expenseType || '').split(',').includes(v))
        return (this.form.expenseType || '').split(',').includes(v)
      }
    },
    getExpenseTypeMap () {
      return ExpenseTypeMap
    },
    getExpenseTypeName () {
      console.log(this.form.expenseType)
      if (!this.form.expenseType) return ''
      let text = []
      this.form.expenseType.split(',').map((i) => {
        const item = this.getExpenseTypeMap.find(j => j.value === i)
        if (item) {
          text.push(item.label)
        }
      })
      console.log(text)
      return text.join(',')
    }
  },
  methods: {
    setExpenseTypes (list) {
      const expenseTypes = [];
      (list || '').split(',').map(i => {
        const item = this.getExpenseTypeMap.find(j => j.value === i)
        if (item) {
          expenseTypes.push(item)
        }
      })
      this.expenseTypes = expenseTypes
    },
    toggle (item) {
      const index = this.expenseTypes.findIndex(i => i.value === item.value)
      if (index !== -1) {
        this.expenseTypes.splice(index, 1)
      } else {
        this.expenseTypes.push(item)
      }
    },
    onConfirm () {
      console.log(this.expenseTypes)
      this.form.expenseType = this.expenseTypes.map(i => i.value).join(',')
      this.$emit('onFocus', {
        field: 'expenseType',
        value: this.expenseTypes.map(i => i.value).join(',')
      })
      this.showPicker = false
    },
    handleCallBack () {
      this.$emit('update:formData', this.form)
    },
    onFocus (item) {
      this.$emit('onFocus', item)
    }
  },
  mounted () {
    this.form = { ...this.formData }
    console.log(this.form, '这里也有')
    this.selfThis = this
  }
}
</script>
<style scoped lang="less">
.popup-content{
  height: calc(100% - 200px);
  display: flex;
  flex-direction: column;
}
.popup-content > header {
  padding: 24px 12px;
  display: flex;
  box-sizing: border-box;
  font-size: 28px;
  justify-content: space-between;
  span:nth-of-type(2) {
    color: #576b95;
  }
  span:nth-of-type(1) {
    color: #969799;
  }
}
.columns{
  height: 0;
  flex-grow: 1;
  overflow-y: scroll;
}
.message {
  width: 718px;
  height: 494px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 8px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
/deep/.van-overlay{
  background-color: rgba(0,0,0,.1);
}
.message > div {
  display: flex;
  height: 96px;
  align-items: center;
  width: 670px;
  margin: 0 auto;
  border-bottom: 1px solid rgba(236, 238, 241, 0.5);
  .label {
    font-size: 26px;
    font-family: Alibaba PuHuiTi;
    font-weight: bold;
    width: 220px;
    color: #1f2433;
  }
  .info {
    flex-grow: 1;
    input{
      width: 100%;
      display: block;
      height: 100%;
      border: none;
      font-size: 26px;
    }
  }
}
.message > div:last-of-type {
  border-bottom: none;
}
</style>
